window.LuhxeBundleBuilder = {

    config: {
      debug: true,
      // Master kill switch for ALL pre-order logic. When true: no pre-order
      // button, no "switch to pre-order" chip, no pre-order styling/messaging,
      // every variant treated as in-stock, only the regular ADD button + normal
      // prices are shown.
      disablePreorder: true,
      autoOpenCart: true,
      propertyKey: 'Estimated to Ship',
      daysUntilShip: 60,
      mountId: 'lux-bundle',
      hideSelectors: ['kaching-bundles-block', '.kaching-bundles'],
  
      ctaAnchorSelectors: ['button.gp-button-atc', '.gp-button-atc', 'gp-product-button', '.gp-product-button', 'product-form button[name="add"]', '.product-form__submit'],
      ctaAnchorWrap: 'gp-product-button, .gp-product-button, product-form, .product-form',
      anchorSelector: 'product-form.product-form, gp-product-button, .gp-product-button',
      preorderOff: 10,
      // Bundle discount (matches the store-level Shopify automatic discount):
      // a flat amount off EACH bag once 2+ bags are in the order, regardless of
      // model (Classic/Roller) or color. e.g. 2 bags => $79 off, 4 bags => $158.
      // Applies to every bag from the 2nd-bag threshold up (perBagOff * qty when
      // qty >= minBagsForDiscount).
      perBagOff: 39.5,
      minBagsForDiscount: 2,
      tierSaveLabel: 'Save 50%',
      // Repurpose the theme's existing "Select Model" label rather than adding a
      // new field label element. Edit this <p>'s innerHTML in place.
      nativeLabelSelector: '#ghGMmigCoP > div.gXfW70Qw9o.gp-relative.gp-flex.gp-flex-col > div > div > div > p',
      nativeLabelText: 'Build Your Bundle',
      freeGifts: ['The Ultimate Traveler\u2019s Guide (92 Pages)', 'Luhxe Shoe Bag', 'Luhxe Cosmetic Bag'],
      nativeAtcSelectors: [
        'product-form button[name="add"]',
        'form[action*="/cart/add"] [type="submit"]',
        '.product-form__submit',
        'button.gp-button-atc',
        '[data-add-to-cart]', '.shopify-payment-button',
      ],
      uspImage: 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/Group_1000009842_1.png?v=1772576289',
      // The following keys are populated per-product at init from PRODUCTS:
      // mainHandle, preorderHandle, saleBarText, badgeText.
    },
  
    /* =========================================================================
     * PRODUCTS — one entry per supported PDP, keyed by its main handle.
     * On init we detect which product page we're on and merge its `config`
     * onto the shared config, and point IDS / SEED / IMG / CATALOG at its data.
     * ====================================================================== */
    PRODUCTS: {
      /* ----------------------------------------------- Luhxe Travel Bag 2.0 (Offer) */
      'luhxe-offer-3': {
        config: {
          mainHandle: 'luhxe-offer-3',
          preorderHandle: 'luhxe-travel-bag-2-0-offer-preorder',
          saleBarText: 'Summer Sale: 2nd Bag 50% Off',
          badgeText: 'Most Popular',
        },
        IDS: {
          main: {
            Rose:     { Classic: '45493471445039', 'Roller Edition': '45493471477807' },
            Charcoal: { Classic: '45493471510575', 'Roller Edition': '45493471543343' },
            Snow:     { Classic: '45493471576111', 'Roller Edition': '45493471608879' },
          },
          preorder: {
            Rose:     { Classic: '45493523709999', 'Roller Edition': '45493523742767' },
            Charcoal: { Classic: '45493523775535', 'Roller Edition': '45493523808303' },
            Snow:     { Classic: '45493523841071', 'Roller Edition': '45493523873839' },
          },
        },
        SEED: {
          main:      { Classic: 129, 'Roller Edition': 179 },
          preorder:  { Classic: 119, 'Roller Edition': 169 },
          compareAt: { Classic: 199.99, 'Roller Edition': 279.99 },
        },
        IMG: {
          'Rose|Classic':            'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/Container-2_2.png?v=1778007670',
          'Rose|Roller Edition':     'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/2_6058d258-0911-440b-a89d-4305a5628e3f.jpg?v=1774632224',
          'Charcoal|Classic':        'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/hf_20260507_143249_74055416-3ea2-4ff3-9399-79266e9d494a_1_1.png?v=1778253093',
          'Charcoal|Roller Edition': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/hf_20260508_173801_2477cee8-d7de-42bd-a7e8-fc6214b3b5c7.png?v=1778693511',
          'Snow|Classic':            'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/Container-1_3.png?v=1778007670',
          'Snow|Roller Edition':     'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/3_abd3b251-d5f3-471d-8f79-b03ec78a8f88.jpg?v=1774632224',
        },
      },
    },
  
    /* Active-product slots. These are pointed at the detected product's data in
     * resolveProduct(); the rest of the engine reads from these exactly as before. */
    IDS: null,
    SEED: null,
    IMG: null,
  
    /* CATALOG / swatches are shared across both products (same colors/models). */
    CATALOG: [
      { key: 'classic-rose',     name: 'Classic \u00b7 Rose',     model: 'Classic',        color: 'Rose',     avail: 'preorder' },
      { key: 'classic-charcoal', name: 'Classic \u00b7 Charcoal', model: 'Classic',        color: 'Charcoal', avail: 'preorder' },
      { key: 'classic-snow',     name: 'Classic \u00b7 Snow',     model: 'Classic',        color: 'Snow',     avail: 'both'     },
      { key: 'roller-rose',      name: 'Roller \u00b7 Rose',      model: 'Roller Edition', color: 'Rose',     avail: 'preorder' },
      { key: 'roller-charcoal',  name: 'Roller \u00b7 Charcoal',  model: 'Roller Edition', color: 'Charcoal', avail: 'preorder' },
      { key: 'roller-snow',      name: 'Roller \u00b7 Snow',      model: 'Roller Edition', color: 'Snow',     avail: 'both'     },
    ],
  
    COLOR_SWATCH: {
      Rose:     'linear-gradient(135deg,#e8b9b0,#d99a8f)',
      Charcoal: 'linear-gradient(135deg,#3a3a3c,#1f1f20)',
      Snow:     'linear-gradient(135deg,#f0ece6,#cfc4b4)',
    },
  
    /* ------------------------------------------------------------------- STATE */
    state: {
      initialized: false,
      pricesLoaded: false,
      rate: 1,
      currency: 'USD',
      prices: { main: {}, preorder: {} },
      compareAt: {},
      cart: {},
      modeState: {},
      manualTarget: 1,
      qty: 1,
      mounted: false,
      activeHandle: null,
    },
  
    /* ------------------------------------------------- PRODUCT RESOLUTION / MODE */
    /* Detect which supported product PDP we're on by matching the URL path
     * against every PRODUCTS entry's mainHandle. Returns the matched handle or
     * null. When matched, merges that product's config + data into place. */
    resolveProduct() {
      const path = location.pathname;
      for (const handle of Object.keys(this.PRODUCTS)) {
        if (path.includes('/products/' + handle)) {
          const product = this.PRODUCTS[handle];
          this.config = { ...this.config, ...product.config };
          this.IDS = product.IDS;
          this.SEED = product.SEED;
          // clone IMG so live overrides don't mutate the static PRODUCTS map
          this.IMG = { ...product.IMG };
          this.state.activeHandle = handle;
          return handle;
        }
      }
      return null;
    },
  
    isOnProduct() { return !!this.state.activeHandle && location.pathname.includes('/products/' + this.config.mainHandle); },
    variant(key) { return this.CATALOG.find(v => v.key === key); },
    modeFor(v) { if (this.config.disablePreorder) return 'instock'; return v.avail === 'preorder' ? 'preorder' : (this.state.modeState[v.key] || 'instock'); },
    isPre(v) { return this.modeFor(v) === 'preorder'; },
    totalInCart() { return Object.values(this.state.cart).reduce((s, n) => s + n, 0); },
    imgFor(v) { return this.IMG[v.color + '|' + v.model] || null; },
  
    /* ----------------------------------------------------------------- PRICING */
    async loadPrices() {
      const rate = (() => { const r = parseFloat(window.Shopify?.currency?.rate); return (!isNaN(r) && r > 0) ? r : 1; })();
      this.state.rate = rate;
      this.state.currency = (window.Shopify?.currency?.active || 'USD').toUpperCase();
  
      const fetchOne = async (h) => {
        const res = await fetch('/products/' + h + '.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('price fetch failed ' + h);
        return res.json();
      };
      const [main, pre] = await Promise.all([fetchOne(this.config.mainHandle), fetchOne(this.config.preorderHandle)]);
  
      const index = (product, bucket) => {
        for (const v of product.variants) {
          const color = v.option1, model = v.option2;
          const baseMajor = (parseFloat(v.price) / 100) / rate;
          if (!this.state.prices[bucket][color]) this.state.prices[bucket][color] = {};
          this.state.prices[bucket][color][model] = baseMajor;
          if (bucket === 'main') {
            if (v.compare_at_price) this.state.compareAt[color + '|' + model] = (parseFloat(v.compare_at_price) / 100) / rate;
            // live per-variant image overrides the seed map
            const src = v.featured_image && v.featured_image.src;
            if (src) this.IMG[color + '|' + model] = src;
          }
        }
      };
      index(main, 'main'); index(pre, 'preorder');
      this.state.pricesLoaded = true;
      if (this.config.debug) console.log('[LuxBundle] prices (base USD)', JSON.parse(JSON.stringify(this.state.prices)), 'rate', rate, this.state.currency, 'handle', this.state.activeHandle);
    },
  
    mainPrice(v) { const p = this.state.prices.main?.[v.color]?.[v.model]; return (typeof p === 'number') ? p : (this.SEED.main[v.model] || 0); },
    prePrice(v) { const p = this.state.prices.preorder?.[v.color]?.[v.model]; return (typeof p === 'number') ? p : (this.SEED.preorder[v.model] || 0); },
    unitPrice(v) { return this.isPre(v) ? this.prePrice(v) : this.mainPrice(v); },
    compareAt(v) { return this.state.compareAt[v.color + '|' + v.model] || this.SEED.compareAt[v.model] || 0; },
  
    variantId(v) {
      const bucket = this.isPre(v) ? 'preorder' : 'main';
      return this.IDS[bucket]?.[v.color]?.[v.model] || null;
    },
  
    /* ---------------------------------------------------------- MONEY FORMATTER */
    money(baseUsd) {
      const display = baseUsd * this.state.rate;
      const cur = this.state.currency;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: cur,
          minimumFractionDigits: (Math.round(display) === +display.toFixed(2)) ? 0 : 2,
          maximumFractionDigits: 2,
        }).format(display);
      } catch (_) {
        const n = (Math.round(display) === +display.toFixed(2)) ? Math.round(display) : display.toFixed(2);
        return '$' + n;
      }
    },
  
    /* Whole-order pricing. The store-level Shopify automatic discount takes a
     * FLAT amount (perBagOff) off EACH bag once the order reaches
     * minBagsForDiscount (2+), regardless of model or color. So the order-level
     * discount is simply perBagOff * n when n >= minBagsForDiscount, else 0.
     * e.g. 2 bags => 2 * $39.50 = $79 off; 4 bags => $158 off. */
    priceOrder() {
      let n = 0, baseSubtotal = 0, compareSubtotal = 0, preSavings = 0, anyPre = false;
      this.CATALOG.forEach(v => {
        const c = this.state.cart[v.key] || 0;
        if (c <= 0) return;
        const pre = this.isPre(v);
        if (pre) anyPre = true;
        const unit = this.unitPrice(v);
        const mainP = this.mainPrice(v);
        for (let i = 0; i < c; i++) {
          n += 1;
          baseSubtotal += unit;
          compareSubtotal += (this.compareAt(v) || mainP);
          if (pre) preSavings += (mainP - unit);
        }
      });
  
      // flat per-bag discount once the threshold is met
      let bundleOff = 0;
      if (n >= this.config.minBagsForDiscount) {
        bundleOff = this.config.perBagOff * n;
      }
      if (bundleOff > baseSubtotal) bundleOff = baseSubtotal; // never below 0
  
      const total = baseSubtotal - bundleOff;
      return { n, baseSubtotal, compareSubtotal, preSavings, bundleOff, total, compareTotal: compareSubtotal, anyPre };
    },
  
    shipDate() {
      const now = new Date();
      const d = new Date(now);
      d.setDate(d.getDate() + this.config.daysUntilShip);
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const day = d.getDate();
      const tens = day % 100;
      const suffix = (tens >= 11 && tens <= 13) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
      let out = months[d.getMonth()] + ' ' + day + suffix;
      if (d.getFullYear() !== now.getFullYear()) out += ', ' + d.getFullYear();
      return out;
    },
  
    syncTierToCart() {
      const t = this.totalInCart();
      this.state.qty = Math.min(Math.max(t, this.state.manualTarget, 1), 2);
    },
  
    injectStyles() {
      if (document.getElementById('lux-bundle-styles')) return;
      const M = '#' + this.config.mountId;
      const css = `
      ${M}{--ink:#2b211d;--ink-soft:#6b5f57;--paper:#f6f1ea;--card:#fff;--line:#e7ddd1;
        --accent:rgba(138, 12, 12, 1);--gold:#b8893b;--sale:#b02525;--radius:7px;--pad:14px;
        color:var(--ink);max-width:440px;margin:0 auto;padding:0;-webkit-font-smoothing:antialiased;}
      ${M} *{box-sizing:border-box;}
          .drawer{
                  z-index: 99999 !important;
          }
      /* ---- tier / progress (compact, matches Figma proportions) ---- */
      ${M} .lux-tier-wrap{margin-top:16px;}
      ${M} .lux-tier-box{background:var(--card);border:1.5px solid var(--ink);border-radius:7px 7px 0 0;
        padding:11px 16px 8px;position:relative;}
      ${M} .lux-badge{position: absolute;
      top: -11px;
      font-size: 10px;
      font-weight: 800;
      letter-spacing: .4px;
      color: #fff;
      background: var(--accent);
      padding: 4px 6px;
      border-radius: 4px;
      text-transform: uppercase;
      white-space: nowrap;
      transform: translateX(-4%);
      left: unset !important;
      right: 0;
      line-height: 100%;
      font-family: 'Helvetica Neue';}
      ${M} .lux-tlabels{display:flex;    justify-content: space-between;}
      ${M} .lux-tlabels .tl{flex:unset;text-align:center;font-weight:600;color:var(--ink-soft);transition:.15s;}
      ${M} .lux-tlabels .tl.active{color:var(--ink);}
      ${M} .lux-track{pointer-events: none; position:relative;display:flex;margin:4px 0 6px;    justify-content: space-between;}
      ${M} .lux-track::before{content:"";position:absolute;top:50%;left:5%;right:25%;height:3px;background:#eadfce;transform:translateY(-50%);border-radius:3px;z-index:0;    width: 90%;}
      ${M} .lux-fill{position: absolute;
      top: 50%;
      left: 5%;
      height: 3px;
      background: var(--accent);
      transform: translateY(-50%);
      border-radius: 3px;
      z-index: 1;
      transition: width .3s ease;
      display: block !important;}
      ${M} .lux-node{flex:unset;display:flex;justify-content:center;position:relative;z-index:2;cursor:pointer;}
      ${M} .lux-node .nd{width:16px;height:16px;border-radius:50%;background:#f1e8da;border:2px solid #f1e8da;transition:.2s;}
      ${M} .lux-node.filled .nd{background:var(--accent);border-color:var(--accent);box-shadow:0 0 0 3px #fff inset;}
      ${M} .lux-node.active .nd{background: var(--accent);
      border: 0px solid var(--accent);
      box-shadow: 0 0 0 2px #fff inset, 0 0 0 1px var(--accent);}
      ${M} .lux-tsaves{display:flex;}
      ${M} .lux-tsaves .ts{flex:1;text-align:right;font-size:11px;font-weight:800;color:var(--ink-soft);text-transform:uppercase;letter-spacing:.3px;transition:.15s;min-height:14px;}
      ${M} .lux-tsaves .ts.active{color:var(--accent);}
      ${M} .lux-salebar{    background: var(--ink);
      color: #fff;
      border-radius: 0 0 7px 7px;
      text-align: center;
      font-weight: 700;
      font-size: 13px;
      padding: 3px 12px;
      font-family: 'Helvetica Neue';}
  
      /* ---- status ---- */
      ${M} .lux-status{display: flex;
      align-items: center;
      gap: 4px 10px;
      margin-top: 14px;
      padding: 8px 14px 7px;
      background: #fff;
      border: 1px solid var(--line);
      border-radius: 7px;
      font-size: 13px;
      font-weight: 700;
      flex-wrap: wrap;}
      ${M} .lux-status .sdot{width:9px;height:9px;border-radius:50%;background:var(--ink-soft);flex:none;}
      ${M} .lux-status.met .sdot{background:#2e7d32;}
      ${M} .lux-status .msg{color:var(--ink);}
      ${M} .lux-status .hint{margin-left:auto;font-weight:600;color:var(--ink-soft);font-size:12px;}
  
      ${M} .lux-fieldlabel{font-size:12px;font-weight:800;letter-spacing:.6px;text-transform:uppercase;color:var(--ink-soft);padding:16px 0 6px;}
  
      /* ---- product cards (Figma-aligned) ---- */
      ${M} .lux-plist{margin-top:2px;}
      ${M} .lux-prow{display:flex;align-items:center;gap:8px;padding:14px 0;border-bottom:1px solid var(--line);}
      ${M} .lux-prow:last-child{border-bottom:none;}
      ${M} .lux-pthumb{width:76px;height:76px;border-radius:4px;flex:none;background-size:cover;background-position:center;background-color:var(--paper);}
      ${M} .lux-pinfo{flex:1;min-width:0;}
      ${M} .lux-pname{font-weight:600;font-size:16px;line-height:1.2;color:var(--ink);}
      ${M} .lux-pprice{font-size: 13px;
      margin-top: 4px;
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
      gap: 4px 6px;
      line-height: 100%;}
      ${M} .lux-pprice .now{color:var(--ink);font-weight:800;font-size:15px;line-height:100%;}
      ${M} .lux-pprice .was{color:var(--ink-soft);text-decoration:line-through;font-size:12.5px;line-height:100%;}
      ${M} .lux-pprice .alt,${M} .lux-pprice .ship{flex-basis:100%;color:var(--accent);font-weight:700;font-size:11px;margin-top:1px;letter-spacing:.2px;line-height:100%;}
      ${M} .lux-mode-chip{display:inline-block;margin-top:8px;border:1px dashed var(--accent);background:#fbf3f3;color:var(--accent);
        font-weight:700;font-size:11px;padding:5px 9px;border-radius:8px;cursor:pointer;line-height:1.2;text-align:left;transition:.12s;}
      ${M} .lux-mode-chip.on{border-style:solid;background:var(--accent);color:#fff;}
      ${M} .lux-mode-chip:active{transform:scale(.98);}
      ${M} .lux-pbtn{flex:none;}
      ${M} .lux-btn-add{border: none;
      background: var(--ink);
      color: #fff;
      font-weight: 800;
      font-size: 12px;
      letter-spacing: .4px;
      padding: 10px 6px;
      border-radius: 7px;
      cursor: pointer;
      min-width: 96px;
      text-transform: uppercase;
      transition: .15s;
      line-height: 100%;
      font-family: 'Helvetica Neue';}
      ${M} .lux-btn-add.pre{background:var(--accent);}
      ${M} .lux-btn-add:active{transform:scale(.97);}
      ${M} .lux-stepper{display:flex;align-items:center;background:var(--ink);border-radius:7px;overflow:hidden;min-width:96px;}
      ${M} .lux-stepper button{border:none;background:var(--ink);color:#fff;font-size:18px;font-weight:700;width:32px;height:32px;cursor:pointer;}
      ${M} .lux-stepper .sval{flex:1;text-align:center;background:#fff;color:var(--ink);font-weight:800;height:32px;line-height:32px;font-size:15px;}
  
      /* ---- summary ---- */
      ${M} .lux-summary{margin-top:16px;background:#fff;border:1px solid var(--line);border-radius:var(--radius);padding:var(--pad);}
      ${M} .lux-stitle{font-size:18px;font-weight:600;margin-bottom:10px;}
      ${M} .lux-sline{display:flex;justify-content:space-between;font-size:14px;padding:5px 0;color:var(--ink-soft);gap:12px;}
      ${M} .lux-sline b{color:var(--ink);font-weight:600;}
      ${M} .lux-sline.disc{color:var(--sale);} ${M} .lux-sline.disc b{color:var(--sale);}
      ${M} .lux-sline.gift{color:var(--accent);font-weight:700;}
      ${M} .lux-ship{color:var(--accent);font-weight:700;border-top:1px dashed var(--line);margin-top:6px;padding-top:8px;}
      ${M} .lux-sdiv{height:1px;background:var(--line);margin:9px 0;}
      ${M} .lux-stotal{display:flex;justify-content:space-between;align-items:baseline;padding-top:4px;}
      ${M} .lux-stotal .lab{font-weight:800;font-size:15px;}
      ${M} .lux-stotal .val{font-weight:600;font-size:25px;}
      ${M} .lux-ssaved{color:var(--sale);font-weight:800;font-size:13px;text-align:right;margin-top:4px;}
  
      ${M} .lux-usp{margin:16px 0 4px;text-align:center;}
      ${M} .lux-usp img{max-width:100%;height:auto;display:block;margin:0 auto;}
  
      /* ---- sticky CTA ---- */
      #lux-sticky{position:fixed;left:0;right:0;bottom:0;background:#fff;border-top:1px solid #e7ddd1;
        padding:12px 16px calc(12px + env(safe-area-inset-bottom));z-index:9998;transform:translateY(120%);
        transition:transform .2s cubic-bezier(.22,1,.36,1);}
      #lux-sticky.show{transform:translateY(0);}
      #lux-sticky .in{max-width:440px;margin:0 auto;}
      #lux-sticky .cta{width:100%;border:none;border-radius:7px;background:var(--accent,#7a1f1f);color:#fff;padding:7px 15px;
        font-weight:800;font-size:16px;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:2px;transition:.15s;}
      #lux-sticky .cta:active{transform:scale(.99);}
      #lux-sticky .cta .l1{display:flex;gap:10px;align-items:baseline;}
      #lux-sticky .cta .was{text-decoration:line-through;opacity:.6;font-weight:600;font-size:14px;}
      #lux-sticky .cta .sub{font-size:12px;font-weight:600;opacity:.9;}
      #lux-sticky .cta.dim{opacity:.6;}
      #lux-sticky .cta.loading{opacity:.7;pointer-events:none;}
      [gp-el-wrapper]:has([option-name="Model"]){
          display: none !important;
      }
      [gp-el-wrapper]:has(kaching-bundle){
          display: none !important;
      }
   
  
      @media(min-width:600px){ ${M}{max-width:440px;} }
      #lux-bundle .lux-btn-add.pre {
      background: #2b211d !important;
  }
  #lux-bundle .lux-plist{
          display: flex;
      flex-direction: column;
  }
  body:not(:has(.kaching-bundles__bar)) gp-product-button{
  display: none !important;
  }
    @media (max-width: 420px) {
  
    ${M} .lux-status{display: flex;
      gap: 4px 8px;
      font-size: 11px;}
      ${M} .lux-status .hint{margin-left:auto;font-weight:600;color:var(--ink-soft);font-size:11px;}
    
    }
      @media (max-width: 385px) {
  
    ${M} .lux-status{display: flex;
      gap: 4px 8px;
      font-size: 10px;}
      ${M} .lux-status .hint{margin-left:auto;font-weight:600;color:var(--ink-soft);font-size:10px;}
    
    }
      @media (max-width: 365px) {
  
    ${M} .lux-status{display: flex;
      gap: 4px;
      font-size: 9px;}
      ${M} .lux-status .hint{margin-left:auto;font-weight:600;color:var(--ink-soft);font-size:9px;}
    
    }

    #lux-bundle .lux-usp{
    display: none !important;
  }

    #lux-bundle {
        max-width: unset;
        margin: 0;
                margin-bottom: 20px;
    }

      `;
      const s = document.createElement('style'); s.id = 'lux-bundle-styles'; s.textContent = css; document.head.appendChild(s);
      if (!document.getElementById('lux-bundle-fonts')) {
        const l = document.createElement('link'); l.id = 'lux-bundle-fonts'; l.rel = 'stylesheet';
        l.href = 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;600;700;800;900&family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&display=swap';
        document.head.appendChild(l);
      }
    },
  
    hideNative() {
      this.config.hideSelectors.forEach(sel =>
        document.querySelectorAll(sel).forEach(el => { el.style.display = 'none'; el.setAttribute('data-lux-hidden', '1'); }));
      this.config.nativeAtcSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          if (el.closest && el.closest('#lux-sticky')) return;
          el.style.setProperty('display', 'none', 'important');
          el.setAttribute('data-lux-hidden', '1');
        });
      });
    },
  
    /* Repurpose the existing GemPages model label ("Select Model") into our
     * "Build Your Bundle" copy, instead of injecting a new element. Idempotent. */
    changeNativeLabel() {
      const sel = this.config.nativeLabelSelector;
      if (!sel) return;
      const el = document.querySelector(sel);
      if (el && el.innerHTML !== this.config.nativeLabelText) {
        el.innerHTML = this.config.nativeLabelText;
      }
    },
  
    /* Resolve the element the widget should be inserted directly BEFORE, so it
     * renders right above the native add-to-cart button we hide. */
    findCtaAnchor() {
      // 1) locate the native ATC button itself
      let btn = null;
      for (const sel of this.config.ctaAnchorSelectors) {
        btn = document.querySelector(sel);
        if (btn) break;
      }
      if (!btn) return null;
      // 2) walk up to its closest meaningful wrapper so we sit above the whole
      //    button block (label/price), not jammed inside the button's flex box.
      const wrap = btn.closest(this.config.ctaAnchorWrap);
      return wrap || btn;
    },
  
    ensureMount() {
      let mount = document.getElementById(this.config.mountId);
      if (mount) return mount;
      mount = document.createElement('div'); mount.id = this.config.mountId;
  
      const ctaAnchor = this.findCtaAnchor();
      if (ctaAnchor && ctaAnchor.parentElement) {
        // insert directly above the native CTA wrapper
        ctaAnchor.parentElement.insertBefore(mount, ctaAnchor);
      } else {
        // fallback: generic anchor, else body
        const anchor = document.querySelector(this.config.anchorSelector);
        if (anchor && anchor.parentElement) anchor.parentElement.insertBefore(mount, anchor);
        else document.body.appendChild(mount);
      }
      this.state.mounted = true;
      return mount;
    },
  
    /* =========================================================================
     * RENDER
     * ====================================================================== */
    render() {
      const mount = this.ensureMount();
      if (!mount.dataset.scaffolded) {
        const saveLabel = this.config.tierSaveLabel || 'Save 50%';
        mount.innerHTML = `
          <div class="lux-tier-wrap">
            <div class="lux-tier-box">
              <span class="lux-badge" id="lux-badge" style="left:75%">${this.config.badgeText || 'Most Popular'}</span>
              <div class="lux-tlabels" id="lux-tlabels"><div class="tl active">1 Bag</div><div class="tl">2 Bags+</div></div>
              <div class="lux-track">
                <div class="lux-fill" id="lux-fill" style="width:0%"></div>
                <div class="lux-node active filled" data-qty="1" data-pos="0"><span class="nd"></span></div>
                <div class="lux-node" data-qty="2" data-pos="1"><span class="nd"></span></div>
              </div>
              <div class="lux-tsaves" id="lux-tsaves"><div class="ts active">&nbsp;</div><div class="ts">${saveLabel}</div></div>
            </div>
            <div class="lux-salebar">${this.config.saleBarText || "2nd Bag 50% Off"}</div>
          </div>
          <div class="lux-status" id="lux-status"><span class="sdot"></span><span class="msg" id="lux-msg">Choose 1 bag</span><span class="hint" id="lux-hint"></span></div>
          <div class="lux-plist" id="lux-plist"></div>
          <div class="lux-summary">
            <div class="lux-stitle" id="lux-stitle">Your Order</div>
            <div id="lux-slines"></div>
            <div class="lux-sdiv"></div>
            <div class="lux-stotal"><span class="lab">Total</span><span class="val" id="lux-grand">$0</span></div>
          </div>
          <div class="lux-usp"><img src="${this.config.uspImage}" alt="Free shipping, easy returns, secure checkout" loading="lazy"></div>`;
        mount.dataset.scaffolded = '1';
        mount.querySelectorAll('.lux-node').forEach(node => node.addEventListener('click', () => {
          this.state.manualTarget = +node.dataset.qty;
          this.syncTierToCart(); this.refresh(); this.setTrack();
        }));
      }
      this.renderList();
      this.setTrack();
      this.refresh();
      this.ensureSticky();
    },
  
    setTrack() {
      const pos = Math.min(this.state.qty, 2) - 1;
      const mount = document.getElementById(this.config.mountId);
      mount.querySelector('#lux-fill').style.width = (pos * 90) + '%';
      mount.querySelectorAll('.lux-node').forEach(node => {
        const pp = +node.dataset.pos;
        node.classList.toggle('filled', pp <= pos);
        node.classList.toggle('active', pp === pos);
      });
      mount.querySelectorAll('#lux-tlabels .tl').forEach((el, idx) => el.classList.toggle('active', idx === pos));
      mount.querySelectorAll('#lux-tsaves .ts').forEach((el, idx) => el.classList.toggle('active', idx === pos));
    },
  
    renderList() {
      const host = document.getElementById('lux-plist');
      host.innerHTML = '';
      const ship = this.shipDate();
  
      this.CATALOG.forEach(v => {
        const count = this.state.cart[v.key] || 0;
        const pre = this.isPre(v);
        const mainP = this.mainPrice(v);
        const preP = this.prePrice(v);
        const cmp = this.compareAt(v) || 0;
  
        let priceHtml;
        if (this.config.disablePreorder) {
          priceHtml = `<div class="lux-pprice">
              <span class="now">${this.money(mainP)}</span>
              ${cmp > mainP ? `<span class="was">${this.money(cmp)}</span>` : ''}
            </div>`;
        } else if (v.avail === 'preorder') {
          priceHtml = `<div class="lux-pprice">
              <span class="now">${this.money(preP)}</span>
              ${cmp > preP ? `<span class="was">${this.money(cmp)}</span>` : ''}
              <span class="ship">Pre-order \u00b7 Ships ${ship}</span>
            </div>`;
        } else {
          const primary = pre ? preP : mainP;
          const alt = pre ? `In stock ${this.money(mainP)} \u00b7 ships now`
                          : `Pre-order ${this.money(preP)} \u00b7 Ships ${ship}`;
          priceHtml = `<div class="lux-pprice">
              <span class="now">${this.money(primary)}</span>
              ${cmp > primary ? `<span class="was">${this.money(cmp)}</span>` : ''}
              <span class="alt">${alt}</span>
            </div>`;
        }

        let chipHtml = '';
        if (!this.config.disablePreorder && count > 0 && v.avail === 'both') {
          const realSaving = Math.max(0, mainP - preP);
          chipHtml = pre
            ? `<button class="lux-mode-chip on" data-key="${v.key}" data-to="instock">\u2713 Pre-order \u00b7 Ships ${ship} \u2014 switch to in-stock</button>`
            : `<button class="lux-mode-chip" data-key="${v.key}" data-to="preorder">Switch to pre-order &amp; save ${this.money(realSaving)} (Ships ${ship})</button>`;
        }
  
        let btnHtml;
        if (count > 0) {
          btnHtml = `<div class="lux-stepper" data-key="${v.key}"><button data-act="dec">\u2212</button><span class="sval">${count}</span><button data-act="inc">+</button></div>`;
        } else if (!this.config.disablePreorder && v.avail === 'preorder') {
          btnHtml = `<button class="lux-btn-add pre" data-key="${v.key}">ADD PRE-ORDER</button>`;
        } else {
          btnHtml = `<button class="lux-btn-add" data-key="${v.key}">ADD</button>`;
        }
  
        const img = this.imgFor(v);
        const thumbStyle = img ? `background-image:url('${img}')` : `background:${this.COLOR_SWATCH[v.color]}`;
        const row = document.createElement('div');
        row.className = 'lux-prow';
        row.innerHTML = `
          <span class="lux-pthumb" style="${thumbStyle}"></span>
          <div class="lux-pinfo"><div class="lux-pname">${v.name}</div>${priceHtml}${chipHtml}</div>
          <div class="lux-pbtn">${btnHtml}</div>`;
        host.appendChild(row);
      });
  
      host.querySelectorAll('.lux-mode-chip').forEach(chip => chip.addEventListener('click', () => {
        this.state.modeState[chip.dataset.key] = chip.dataset.to;
        this.renderList(); this.refresh();
      }));
      host.querySelectorAll('.lux-btn-add').forEach(b => b.addEventListener('click', () => {
        this.state.cart[b.dataset.key] = 1;
        this.syncTierToCart(); this.renderList(); this.setTrack(); this.refresh();
      }));
      host.querySelectorAll('.lux-stepper').forEach(s => {
        const key = s.dataset.key;
        s.querySelector('[data-act=inc]').addEventListener('click', () => {
          this.state.cart[key]++; this.syncTierToCart(); this.renderList(); this.setTrack(); this.refresh();
        });
        s.querySelector('[data-act=dec]').addEventListener('click', () => {
          this.state.cart[key]--; if (this.state.cart[key] <= 0) delete this.state.cart[key];
          this.syncTierToCart(); this.renderList(); this.setTrack(); this.refresh();
        });
      });
    },
  
    refresh() {
      const mount = document.getElementById(this.config.mountId);
      const p = this.priceOrder();
      const target = this.state.qty;
      const n = p.n;
      const ship = this.shipDate();
  
      const status = mount.querySelector('#lux-status');
      const msg = mount.querySelector('#lux-msg');
      const hint = mount.querySelector('#lux-hint');
      if (n === 0) { msg.textContent = `Choose ${target} ${target > 1 ? 'bags' : 'bag'}`; hint.textContent = ''; status.classList.remove('met'); }
      else if (n < target) { msg.textContent = `${n} of ${target} chosen`; hint.textContent = `Add ${target - n} more to unlock the discount`; status.classList.remove('met'); }
      else { msg.textContent = `${n} ${n > 1 ? 'bags' : 'bag'} in your bundle`; hint.textContent = p.bundleOff > 0 ? 'Bundle discount applied' : ''; status.classList.add('met'); }
  
      // summary lines
      let lines = '';
      if (n >= 2) {
        this.CATALOG.forEach(v => {
          const c = this.state.cart[v.key] || 0;
          if (c > 0) {
            const label = `${v.name}${c > 1 ? ' \u00d7' + c : ''}${this.isPre(v) ? ' (pre-order)' : ''}`;
            lines += `<div class="lux-sline"><span>${label}</span><b>\u2713 included</b></div>`;
          }
        });
        lines += `<div class="lux-sline disc"><span>Bundle price \u2014 2nd bag 50% off</span><b>${this.money(p.total > 0 ? p.total : 0)}</b></div>`;
      } else {
        this.CATALOG.forEach(v => {
          const c = this.state.cart[v.key] || 0;
          if (c > 0) {
            const unit = this.unitPrice(v);
            lines += `<div class="lux-sline"><span>${v.name}${this.isPre(v) ? ' (pre-order)' : ''}${c > 1 ? ' \u00d7' + c : ''}</span><b>${this.money(unit * c)}</b></div>`;
          }
        });
      }
      if (!lines) lines = `<div class="lux-sline"><span>No bags selected yet</span><b>\u2014</b></div>`;
      if (p.anyPre) lines += `<div class="lux-sline gift"><span>\uD83C\uDF81 ${this.config.freeGifts.length} free gifts included</span><b>FREE</b></div>`;
      if (p.anyPre) lines += `<div class="lux-sline lux-ship"><span>\uD83D\uDCE6 Pre-order items ship</span><b>${ship}</b></div>`;
      mount.querySelector('#lux-slines').innerHTML = lines;
  
      mount.querySelector('#lux-stitle').textContent = n >= 2 ? 'Your Pair' : 'Your Order';
      mount.querySelector('#lux-grand').textContent = this.money(p.total > 0 ? p.total : 0);
  
      this.refreshSticky(p);
    },
  
    /* ------------------------------------------------------------- STICKY CTA */
    ensureSticky() {
      if (document.getElementById('lux-sticky')) return;
      const sticky = document.createElement('div');
      sticky.id = 'lux-sticky';
      sticky.innerHTML = `<div class="in"><button class="cta dim" id="lux-cta">
          <span class="l1"><span id="lux-cta-label">Select Your Bags</span><span id="lux-cta-dash" style="display:none"> \u2014 </span><span id="lux-cta-total"></span>
            <span class="was" id="lux-cta-was"></span></span>
          <span class="sub" id="lux-cta-sub">${this.config.saleBarText || 'Sale'}</span></button></div>`;
      document.body.appendChild(sticky);
      sticky.querySelector('#lux-cta').addEventListener('click', () => this.commitOrderToCart());
      this.bindStickyScroll();
    },
  
    refreshSticky(p) {
      const sticky = document.getElementById('lux-sticky');
      if (!sticky) return;
      const n = p.n, target = this.state.qty;
      const label = sticky.querySelector('#lux-cta-label');
      const dash = sticky.querySelector('#lux-cta-dash');
      const total = sticky.querySelector('#lux-cta-total');
      const was = sticky.querySelector('#lux-cta-was');
      const sub = sticky.querySelector('#lux-cta-sub');
      const cta = sticky.querySelector('#lux-cta');
  
      if (n === 0) {
        // nothing selected -> prompt, hide price
        label.textContent = 'Select Your Bags';
        dash.style.display = 'none';
        total.textContent = '';
        was.style.display = 'none';
        cta.classList.add('dim');
        sub.textContent = this.config.saleBarText || 'Sale';
        return;
      }
  
      dash.style.display = '';
      total.textContent = this.money(p.total > 0 ? p.total : 0);
      if (p.compareTotal > p.total) { was.textContent = this.money(p.compareTotal); was.style.display = ''; }
      else was.style.display = 'none';
  
      if (n < target) { label.textContent = `Add ${target - n} more`; cta.classList.remove('dim'); }
      else { label.textContent = (n >= 2 ? 'Add the Bundle' : 'Add to Cart'); cta.classList.remove('dim'); }
  
      sub.textContent = p.anyPre ? `Includes pre-order \u00b7 ships ${this.shipDate()}` : 'In stock \u00b7 ships now';
    },
  
    bindStickyScroll() {
      const anchor = document.getElementById(this.config.mountId);
      const sticky = document.getElementById('lux-sticky');
      if (!anchor || !sticky || !('IntersectionObserver' in window)) { if (sticky) sticky.classList.add('show'); return; }
      const io = new IntersectionObserver((entries) => {
        const e = entries[0]; if (!e) return;
        if (e.isIntersecting) sticky.classList.add('show');
        else if (e.boundingClientRect.top > 0) sticky.classList.remove('show');
        else sticky.classList.add('show');
      }, { threshold: 0 });
      io.observe(anchor);
      const footer = document.querySelector('footer');
      if (footer) {
        const fio = new IntersectionObserver((entries) => { if (entries[0]?.isIntersecting) sticky.classList.remove('show'); }, { threshold: 0 });
        fio.observe(footer);
      }
    },
  
    /* ------------------------------------------------------------ COMMIT ORDER */
    buildCartItems() {
      const items = [];
      this.CATALOG.forEach(v => {
        const c = this.state.cart[v.key] || 0;
        if (c <= 0) return;
        const id = this.variantId(v);
        if (!id) return;
        const props = this.isPre(v) ? { [this.config.propertyKey]: this.shipDate() } : {};
        items.push({ id, quantity: c, properties: props });
      });
      return items;
    },
  
    async commitOrderToCart() {
      const items = this.buildCartItems();
      if (!items.length) {
        document.getElementById(this.config.mountId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      const cta = document.getElementById('lux-cta');
      if (cta) cta.classList.add('loading');
      try {
        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        const cartEl = cartDrawer || cartNotification;
        let sections = [];
        if (cartEl && typeof cartEl.getSectionsToRender === 'function') sections = cartEl.getSectionsToRender().map(s => s.id);
        const body = { items };
        if (sections.length) { body.sections = sections.join(','); body.sections_url = location.pathname; }
  
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || err.message || ('add failed (HTTP ' + res.status + ')')); }
        const data = await res.json();
  
        if (cartEl && typeof cartEl.renderContents === 'function') { cartEl.renderContents(data); if (cartDrawer) cartDrawer.classList.remove('is-empty'); }
        if (this.config.autoOpenCart) {
          await new Promise(r => setTimeout(r, 250));
          if (cartEl && typeof cartEl.open === 'function') cartEl.open();
          else this.clickCartIcon();
        }
        if (this.config.debug) console.log('[LuxBundle] committed order', items);
      } catch (e) {
        console.error('[LuxBundle] commit error', e);
        alert('Couldn\u2019t add to cart: ' + ((e && e.message) ? e.message : 'something went wrong. Please try again.'));
      } finally {
        if (cta) cta.classList.remove('loading');
      }
    },
  
    clickCartIcon() {
      const sels = ['#cart-icon-bubble', '[data-cart-drawer-toggle]', '.header__icon--cart', 'a[href="/cart"]'];
      for (const s of sels) { const el = document.querySelector(s); if (el) { el.click(); return; } }
    },
  
    /* =========================================================================
     * INIT
     * ====================================================================== */
    async init(customConfig = {}) {
      // Detect which supported product we're on BEFORE anything else. If none
      // matches, stay inert. customConfig still overrides afterward (e.g. debug).
      const handle = this.resolveProduct();
      if (!handle) { if (this.config.debug) console.log('[LuxBundle] inert (not a supported PDP)'); return this; }
  
      this.config = { ...this.config, ...customConfig };
      if (!this.isOnProduct()) { if (this.config.debug) console.log('[LuxBundle] inert (not target PDP)'); return this; }
      if (this.state.initialized) return this;
      this.state.initialized = true;
  
      if (this.config.debug) console.log('[LuxBundle] active product', handle);
  
      this.injectStyles();
      // Mount + render IMMEDIATELY using seed prices so there's no perceptible
      // delay. If the anchor isn't in the DOM yet, retry briefly without blocking.
      if (!this.tryRenderNow()) {
        this.waitFor(this.config.anchorSelector, 8000).then(() => this.tryRenderNow()).catch(() => {});
      }
      this.hideNative();
      // Load live prices in the BACKGROUND; refresh the UI when they arrive.
      this.loadPrices()
        .then(() => { if (document.getElementById(this.config.mountId)) { this.renderList(); this.refresh(); } })
        .catch((e) => { if (this.config.debug) console.warn('[LuxBundle] price load failed', e); });
      this.startObserver();
      return this;
    },
  
    /* Render now if the mount target is available; returns true if rendered. */
    tryRenderNow() {
      if (document.getElementById(this.config.mountId)) return true; // already mounted
      const ctaAnchor = this.findCtaAnchor();
      const fallback = document.querySelector(this.config.anchorSelector);
      if (!ctaAnchor && !fallback) return false;
      this.changeNativeLabel();
      this.render();
      return true;
    },
  
    waitFor(selector, timeout = 6000) {
      return new Promise((resolve, reject) => {
        const el = document.querySelector(selector); if (el) return resolve(el);
        const obs = new MutationObserver(() => { const e = document.querySelector(selector); if (e) { obs.disconnect(); resolve(e); } });
        obs.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => { obs.disconnect(); reject(new Error('timeout')); }, timeout);
      });
    },
  
    startObserver() {
      let t = null;
      const debounced = () => { if (t) clearTimeout(t); t = setTimeout(() => {
        this.hideNative();
        this.changeNativeLabel();
        if (!document.getElementById(this.config.mountId)) this.tryRenderNow();
      }, 150); };
      const obs = new MutationObserver((muts) => {
        for (const m of muts) for (const node of m.addedNodes) {
          if (node.nodeType === 1 && (node.matches?.(this.config.anchorSelector) || node.querySelector?.(this.config.anchorSelector) || (node.className && ('' + node.className).includes('kaching')))) return debounced();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    },
  };
  
  // auto-init
  (function () {
    const go = () => window.LuhxeBundleBuilder.init();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
    else go();
  })();